import { useApi } from './use-api-call';
import { ProductDTO } from './product-api';

export const useSearchProductPostPurchaseFeatureApi = () =>
    useApi<{
        productPostPurchaseFeatures: ProductPostPurchaseFeatureDTO[];
        products: ProductDTO[];
        allowEdit: boolean;
    }>('/product-post-purchase-feature/search-product-post-purchase-feature');

export const useGetProductPostPurchaseFeatureApi = () =>
    useApi<{ productPostPurchaseFeature: ProductPostPurchaseFeatureDTO; allowEdit: boolean }>(
        '/product-post-purchase-feature/get-product-post-purchase-feature/{id}'
    );

export const useSaveProductPostPurchaseFeatureApi = () =>
    useApi<{ productPostPurchaseFeatures: ProductPostPurchaseFeatureDTO[] }>('/product-post-purchase-feature/save-product-post-purchase-feature');

export const useDeleteProductPostPurchaseFeatureApi = () =>
    useApi('/product-post-purchase-feature/delete-product-post-purchase-feature/{id}');

export interface ProductPostPurchaseFeatureDTO {
    id: number;
    productId: number;
    value: string;
    link?: string;
}

